import { z } from 'zod';
import { CpfVO, NameSchema, PhoneVO } from "../../../../common/validators/value-objects.js";
export const BasePersonDTOSchema = z.object({
    id: z.uuid(),
    name: NameSchema,
    cpf: CpfVO,
    birthDate: z.coerce.date().nullable(),
    // Default to null: populated only when staff confirms the data-confirmation
    // page; legacy person-create payloads don't need to send them.
    motherName: NameSchema.nullable().default(null),
    // Cents.
    estimatedIncome: z.number().int().positive().nullable().default(null),
    phone: PhoneVO.nullable(),
    email: z.email().nullable(),
    celcoinId: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    isDeleted: z.boolean(),
});
export const ExposedPersonDTOSchema = BasePersonDTOSchema.omit({
    celcoinId: true,
    isDeleted: true,
    deletedAt: true,
});
//# sourceMappingURL=persons.dto.js.map